<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">銀行振込決済(収納代行)エラー</h2>
      <p class="point_error_notice">銀行振込決済(収納代行)でエラーが発生しました。</p>
      <p>
        <router-link :to="{ name: 'PointBankAnotherlaneForm' }" class="arrow link_main--text">銀行振込決済(収納代行)ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointBankAnotherlaneError'
}
</script>
